import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dynamic-date',
  templateUrl: './dynamic-date.component.html',
  styleUrls: ['./dynamic-date.component.scss']
})
export class DynamicDateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
